import { useState } from 'react';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { markOrderAsResigned } from '@/API/repositories/order';

export const useResignOrder = (refreshCb) => {
	const { addMessage } = useMessageQueueContext();
	const { makeRequest } = useRequestsContext();

	const [showResignConfirmationPopup, setShowResignConfirmationPopup] =
		useState(false);
	const [orderToResign, setOrderToResign] = useState();

	const handleResignButtonClick = (orderToResign) => {
		setOrderToResign(orderToResign);
		setShowResignConfirmationPopup(true);
	};

	const handleResignConfirm = async (
		e,
		reason,
		commentManual,
		resignedTags,
	) => {
		e.preventDefault();
		setShowResignConfirmationPopup(false);

		const payload = {};

		payload._id = orderToResign._id;
		payload.comment = reason;
		payload.comment_manual = commentManual;
		payload.resign_tags = resignedTags;

		const response = await makeRequest(markOrderAsResigned.bind(null, payload));

		if (response.data) {
			addMessage('Marked order as resigned', 'success');
			setOrderToResign(() => null);
			refreshCb();
		} else {
			addMessage('Error', 'Error');
		}
	};

	return {
		handleResignConfirm,
		setShowResignConfirmationPopup,
		showResignConfirmationPopup,
		handleResignButtonClick,
	};
};
